import React from 'react';
import { observer } from 'mobx-react';
import { getSmarterElementsInstance } from '../../config';

const SmarterElements = getSmarterElementsInstance();

// Translations
import translate from '../Translate.js';

// Components

const SessionPlayer = observer(class SessionPlayer extends React.Component {
  
  componentWillMount() {
    this.state = {
    }
  }
    
componentDidMount() {
    
    const { SessionStore } = this.props.store;
    const { userSid } = SessionStore.userData;
    const { token } = SessionStore;
    const examSession = this.props.session;
    

      let SessionViewer = null;

      // get the position of the session viewer container
    // wait for the dom to be ready
      //document.addEventListener('DOMContentLoaded', function() {
      if(this && this.refs && this.refs["v3-container"] && SmarterElements){
        function resizeContainer() {
        
            const scontainer = document.getElementById('v3-container');
            const containerRect = scontainer.getBoundingClientRect();
            
            const containerTop = containerRect.top + 10;
            // get the px amoutn for the vh
            const vh = window.innerHeight;
            scontainer.style.height = vh - containerTop + 'px';
            
            if(SessionViewer){
                SessionViewer.updateConstraints({
                    maxHeight: vh - containerTop,
                }); 
                SessionViewer.recalculateSize();
            }
        }

        resizeContainer();
        
        // ensure that the resizing is performat...
        const debouncedResize = window.SmarterElements.throttle(() => {
            resizeContainer();
        }, 250);

        // add a lisenter that will run on document resize to resize the contaner
        window.addEventListener('resize', debouncedResize);
      }


      // Create a session viewer
      const viewerProperties = {
        sessionSid: examSession.sid,
        installSid: examSession.installSid,
        examSid: examSession.examSid,
        token: token,
        identity: userSid,
        viewMode: 'instructor',
        allowPopout: true,
        enabledComponents: {
          controls: true,
          sessionDetails: {
            tabs: ['info', 'identity', 'flags', 'communication', 'incidentReport']
          }, 

          annotations: true,
          timeline: true,
        },  
        elementId: 'v3-container',
        autoResize: true,
        resizeOffset: 10,
      };

      SessionViewer = SmarterElements.create('proctoring/session-viewer', viewerProperties);
      SessionViewer.mount(this.refs["v3-container"]);
  }



  render() {
      return (
        <React.Fragment>
        <style>
            {`
            .drawer__close {
                margin-right: 15px;
            }
            `}
        </style>
        <div id="v3-container" ref="v3-container" style={{ width: '100%', height: 'calc(100vh - 82px)', marginTop: '20px' }}></div>
        </React.Fragment>
    );
  }
})

export default translate('SessionPlayer')(SessionPlayer);


// WEBPACK FOOTER //
// ./src/app/components/Sessions/SessionPlayer.js